import React from 'react';
import styled from 'styled-components';

const IconWrapper = styled.span`
  position: relative;
  display: inline-flex;
`;

const BadgeWrapper = styled.span`
  position: absolute;
  right: -5px;
  bottom: -4px;
  display: inline-flex;
  background: #ffffff;
  border-radius: 50%;
`;

// A paper plane with a small badge icon in its bottom-right corner, as in the
// design (status icons and "Schedule resend to non-openers").
const PlaneIcon = React.forwardRef(({ color, Badge, ...props }, ref) => (
  <IconWrapper ref={ref} {...props}>
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path
        d="M3 4l18 8-18 8 3-8-3-8zm3 8h7"
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
    <BadgeWrapper>
      <Badge style={{ fontSize: 11, color }} />
    </BadgeWrapper>
  </IconWrapper>
));

PlaneIcon.displayName = 'PlaneIcon';

export default PlaneIcon;
